import React from 'react';
import classNames from 'classnames';
import { SelectNew } from '../../../components/SelectNew';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/**
 * Primary UI component for user interaction
 */
export var Tabs = function Tabs(_ref) {
  var tabs = _ref.tabs,
      selectedTab = _ref.selectedTab,
      onSelect = _ref.onSelect,
      children = _ref.children;

  var onSelectTabHandler = function onSelectTabHandler(tab) {
    if (onSelect instanceof Function) {
      onSelect(tab);
    }
  };

  var tabOptionsForSelect = tabs.map(function (tabOption) {
    return {
      label: tabOption.title,
      value: tabOption.tab
    };
  });
  return /*#__PURE__*/_jsxs("div", {
    className: "w-full md:overflow-auto md:no-scrollbar",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "block md:hidden",
      children: [/*#__PURE__*/_jsx(SelectNew, {
        name: "Tabs",
        options: tabOptionsForSelect,
        onChange: function onChange(name, value) {
          return onSelectTabHandler(tabs.find(function (t) {
            return t.tab === value;
          }));
        },
        selectedValue: selectedTab.tab
      }), /*#__PURE__*/_jsx("div", {
        className: "mt-4",
        children: children
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "hidden md:block w-max md:w-full",
      children: /*#__PURE__*/_jsxs("div", {
        className: "border-bottom bc-gray-10 flex",
        children: [tabs.map(function (currentTab, index) {
          var title = currentTab.title,
              tab = currentTab.tab;
          var isSelected = tab === selectedTab.tab;
          return /*#__PURE__*/_jsx("div", {
            className: classNames('text-base font-medium py-2 mr-6 clickable', {
              'border-bottom border-b-2 border-subkit-primary text-subkit-primary': isSelected,
              'text-neutral-400': !isSelected,
              'ml-6': index !== 0
            }),
            onClick: function onClick() {
              return onSelectTabHandler(currentTab);
            },
            "data-cy": title.split(' ').join('_'),
            children: title
          }, index);
        }), children]
      })
    })]
  });
};